"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBMIT_OPENING_METER_READINGS_SECTION_ID = exports.SUBMIT_METER_READINGS_SECTION_ID = exports.METER_READINGS_HOW_TO_READ_ID = exports.METER_READINGS_SECTION_ID = exports.METER_READING_FORM_ERROR = exports.METER_READINGS_DATA_ERROR_SECTION_ID = exports.METER_READ_PAGE_ERROR = void 0;
exports.METER_READ_PAGE_ERROR = 'kapi-meter-read-page-error-boundary';
exports.METER_READINGS_DATA_ERROR_SECTION_ID = 'kapi-meter-readings-data-error-section';
exports.METER_READING_FORM_ERROR = 'kapi-meter-reading-form_error';
exports.METER_READINGS_SECTION_ID = 'kapi-meter-readings';
exports.METER_READINGS_HOW_TO_READ_ID = 'kapi-meter-readings-how-to-read';
exports.SUBMIT_METER_READINGS_SECTION_ID = 'kapi-submit-meter-readings';
exports.SUBMIT_OPENING_METER_READINGS_SECTION_ID = 'kapi-submit-opening-meter-readings';
